<template>
  <div>
    <app-notification :title="'קרתה תקלה, התזרים לא מעודכן.'"
                  :text="'הצוות שלנו עובד כדי לתקן אותה מהר! נשלח לך לינק לתזרים מעודכן ברגע שהיא תיפתר.'"
                  :icon-type="'danger'"/>
  </div>
</template>

<script>
import Segment from '../../../../../../../Segment';
import AppNotification from '../AppNotification.vue';

export default {
  name: 'OutOfDateNotification',
  components: {
    AppNotification,
  },
  async created() {
    Segment.trackUserGot('OutOfDateNotificationShown');
  },
};
</script>

<style lang="scss" scoped>
</style>
